import {put} from "redux-saga/effects";

import axios from "../../../../../api/axios"

import * as actions from "../../../../actions";
import * as api from "../../../../../api";
import {generateDynamicRoute} from "../../../../../utils/utils";

export function* technicianVideoRequestsTerminateVideoRequestSaga(action) {

    yield put(actions.technicianVideoRequestsTerminateVideoRequestStart());

    const videoRequestId = action.payload.videoRequestId;


    try {
        const response = yield axios.put(generateDynamicRoute(api.technicianVideoRequestsTerminateVideoRequest,[{toReplace:":videoRequestId",value:videoRequestId}]));
        console.log(response.data);
        yield put(actions.technicianVideoRequestsTerminateVideoRequestSuccess(response.data));
    } catch (error) {
        if(error.response) {
            yield put(actions.technicianVideoRequestsTerminateVideoRequestFail(error.response.data.error));
        }else {
            yield put(actions.technicianVideoRequestsTerminateVideoRequestFail("There's an error!"));
        }
    }

}